import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom/client';
import { getAppConfig } from '@/lib/env';
import globalCss from '@/styles/globals.css';
import EmbedFixedAgentClient from './agent-client';
const scriptTag = document.querySelector('script[data-lk-sandbox-id]');
const sandboxIdAttribute = scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.dataset.lkSandboxId;
const hashAttribute = (scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.dataset.hash) || (scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.getAttribute('data-hash')) || undefined;
console.log('🔍 Debug - Hash capturado:', hashAttribute);
console.log('🔍 Debug - Sandbox ID:', sandboxIdAttribute);
if (sandboxIdAttribute) {
    const wrapper = document.createElement('div');
    wrapper.setAttribute('id', 'lk-embed-wrapper');
    document.body.appendChild(wrapper);
    // Use a shadow root so that any relevant css classes don't leak out and effect the broader page
    const shadowRoot = wrapper.attachShadow({ mode: 'open' });
    // Include all app styles into the shadow root
    // FIXME: this includes styles for the welcome page / etc, not just the popup embed!
    const styleTag = document.createElement('style');
    styleTag.textContent = globalCss;
    shadowRoot.appendChild(styleTag);
    const reactRoot = document.createElement('div');
    shadowRoot.appendChild(reactRoot);
    getAppConfig(window.location.origin, sandboxIdAttribute)
        .then((appConfig) => {
        const root = ReactDOM.createRoot(reactRoot);
        root.render(_jsx(EmbedFixedAgentClient, { appConfig: appConfig, restaurantHash: hashAttribute }));
    })
        .catch((err) => {
        console.error('LiveKit popup embed error - Error loading app config:', err);
    });
}
else {
    console.error('LiveKit popup embed error - no data-lk-sandbox-id attribute found on script tag. This is required!');
}
